<template>
  <q-card-section>
    <div class="text-h6"><q-avatar color="black" size="xs" /> {{ t('form.addActivity') }}</div>
  </q-card-section>

  <q-card-section class="q-pa-none">
    <q-list>
      <q-item
        v-for="(item, activityIndex) in navActivities"
        :key="activityIndex"
        clickable
        @click="item.type !== 'store' ? (modals[activityIndex] = !modals[activityIndex]) : ''"
        v-ripple
      >
        <q-item-section avatar>
          <q-avatar size="sm" :color="item.color" text-color="white" :icon="item.icon" />
        </q-item-section>
        <q-item-section>{{ activityLabel(item.type) }}</q-item-section>
        <q-dialog v-model="modals[activityIndex]">
          <modal-forms
            :insert-data="insertData"
            :modal-type="item"
            @close-modal="modals[activityIndex] = false"
          />
        </q-dialog>
      </q-item>
    </q-list>
  </q-card-section>

  <q-card-actions align="right" class="text-primary">
    <q-btn flat :label="t('form.close')" v-close-popup />
  </q-card-actions>
</template>
<script lang="ts">
import { NavActivities } from '../types/navigation'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ModalForms from './ModalForms.vue'
import { useNavActivity } from '../composables/activityMeta'
export default defineComponent({
  components: { ModalForms },
  props: {
    insertData: { required: true, type: Object },
  },
  setup() {
    //translations
    const { t } = useI18n({ useScope: 'global' })
    const activityLabel = (key: string) => t(`activities.${key}`)
    const navActivities: NavActivities = useNavActivity().all({ omit: ['store'] })
    const modals = ref<boolean[]>([])
    return {
      //translations
      activityLabel,
      //activities
      navActivities,
      modals,
      t,
    }
  },
})
</script>
